import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'antd';
import { ExportAnalysisButton } from '../../components/ExportAnalysisButton';

import { AnalysisPlotsContainer, AnalysisPlotsTitle, StyledColumn, StyledLine, GroupedLine } from './style';

export const AnalysisPlots = ({ data, company }) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (!data) return;
  }, [data]);

  const { configDataset, groupedConfig, configPercentage, configErrorsDetails, configSources } = data;

  return (
    <AnalysisPlotsContainer>
      <Row>
        <Col span={24}>
          <AnalysisPlotsTitle>
            {t('myCompanies.generalAnalytics')}
            <ExportAnalysisButton companyData={company} action='errors' />
          </AnalysisPlotsTitle>
          <StyledLine {...configDataset} />
        </Col>
      </Row>
      <Row>
        <Col span={12} push={12}>
          <AnalysisPlotsTitle>
            {t('myCompanies.sorterImportExport')}
            <ExportAnalysisButton companyData={company} action='importexport' />
          </AnalysisPlotsTitle>
          <GroupedLine {...groupedConfig}></GroupedLine>
        </Col>
        <Col span={12} pull={12}>
          <AnalysisPlotsTitle>
            {t('myCompanies.sortersPercentage')}
            <ExportAnalysisButton companyData={company} action='sorterspercentage' />
          </AnalysisPlotsTitle>
          <StyledColumn {...configPercentage} />
        </Col>
      </Row>
      <Row>
        <Col span={12} push={12}>
          <AnalysisPlotsTitle>
            {t('myCompanies.errorsTypesPerDay')}
            <ExportAnalysisButton companyData={company} action='errorsdetails' />
          </AnalysisPlotsTitle>
          <StyledLine {...configErrorsDetails} />
        </Col>
        <Col span={11} pull={12}>
          <AnalysisPlotsTitle>
            {t('myCompanies.packagesPerSource')}
            <ExportAnalysisButton companyData={company} action='sorters' />
          </AnalysisPlotsTitle>
          <StyledLine {...configSources}></StyledLine>
        </Col>
      </Row>
    </AnalysisPlotsContainer>
  );
};
